class Param {
  deviceId
  value
  axisId
  title

  constructor (deviceId, value, axisId, title) {
    this.deviceId = deviceId
    this.value = value
    this.axisId = axisId
    this.title = title
  }

  getId () {
    return Param.normalizeDeviceKey(this.deviceId, this.value)
  }

  static normalizeDeviceKey (id, key) {
    return String(id) + '_' + String(key).toLowerCase().split(' ').join('_').split('-').join('_')
  }

  getTitle () {
    return this.title
  }
}

export default Param
